export default __webpack_public_path__ + "static/media/sse.914e0800.svg";